<script setup lang="ts">
  import { MpFile } from '@borg/types';
  import { MpField } from '@borg/ui';
  import { isUndefined, toggleElementInArray } from '@borg/utils';

  const props = defineProps<{
    modelValue: string[];
  }>();

  const emit = defineEmits<{
    (event: 'update:modelValue', value: string[]): void;
  }>();

  const application = jobApplicationRepository.use();
  const { errorMessage, filesForUpload, onFilesForUploadSelected } = useValidateFilesBeforeUpload();

  function onToggleDocument(file: MpFile) {
    emit('update:modelValue', toggleElementInArray(props.modelValue, file.id));
  }

  function onDocumentUploaded(file: MpFile) {
    application.value?.documents.unshift(file);
    emit('update:modelValue', [...props.modelValue, file.id]);
  }

  function onDocumentDeleted(file: MpFile) {
    if (application.value) {
      application.value.documents = application.value.documents.filter((f) => f.id !== file.id);
    }
  }

  function onDocumentEdited(file: MpFile) {
    const documentIndex = application.value?.documents.findIndex((f) => f.id === file.id);
    if (application.value && !isUndefined(documentIndex) && documentIndex >= 0) {
      application.value.documents[documentIndex] = file;
    }
  }
</script>

<template>
  <DocumentsList
    source="document"
    :model-value="props.modelValue"
    :files="application?.documents"
    :files-for-upload="filesForUpload"
    selectable
    multi-selectable
    @toggle="onToggleDocument"
    @file-deleted="onDocumentDeleted"
    @file-uploaded="onDocumentUploaded"
    @file-edited="onDocumentEdited"
  />
  <MpField :error="errorMessage">
    <UploadSurface
      :has-error="!!errorMessage"
      :accept="DEFAULT_HTML_ACCEPT_PARAMETER"
      class="other-upload-surface"
      @change="onFilesForUploadSelected"
    />
  </MpField>
</template>

<style scoped lang="scss">
  .other-upload-surface {
    margin-top: var(--mp-space-50);
  }
</style>
